import React, { useEffect, useRef, useMemo, useState } from "react";
import esriConfig from "@arcgis/core/config.js";
import "@arcgis/map-components/components/arcgis-map";
//import Graphic from "@arcgis/core/Graphic.js";
import GraphicsLayer from "@arcgis/core/layers/GraphicsLayer";

const PreviewMap = ({
  points,
  centroid,
  currentPhoto,
  setIndex,
  removedPoints,
}) => {
  esriConfig.portalUrl = "https://gis.thompsoncs.net/arcgis";
  const mapRef = useRef();

  const [view, setView] = useState();

  useMemo(() => {
    const setupMap = async () => {
      await mapRef.current?.viewOnReady();

      const baseLayer = new GraphicsLayer();

      baseLayer.addMany(points);

      mapRef.current?.map?.add(baseLayer);
      setView(mapRef.current);
    };
    if (points?.length) setupMap();
  }, [points]);

  useEffect(() => {
    const removeLayer = new GraphicsLayer();
    removeLayer.addMany(removedPoints);
    view?.map?.add(removeLayer);
  }, [removedPoints, view]);

  useEffect(() => {
    view?.graphics?.removeAll();
    view?.graphics?.add(currentPhoto);
  }, [currentPhoto, view]);

  useEffect(() => {
    if (view) {
      view.addEventListener("arcgisViewClick", async (event) => {
        const hit = await view.hitTest(event.detail);
        if (hit.results.length > 0) {
          const feature = hit.results[0];
          if (feature.type === "graphic") {
            const id = feature.graphic.attributes.id;
            setIndex(id);
          }
        }
      });
    } else {
      return;
    }
  }, [view, setIndex]);

  return (
    <arcgis-map
      ref={mapRef}
      item-id="cc93f41af383470594965e115c754a8c"
      style={{ height: "800px" }}
      center={centroid}
      zoom={20}
      autoDestroyDisabled={true}
    ></arcgis-map>
  );
};

export default PreviewMap;
